/**
 * Short label for Bullion UI (e.g. "Kolkata Knight Riders" → "KKR", "Gujarat Titans" → "GT").
 */
export function bullionTeamAbbreviation(teamName: string): string {
    const words = String(teamName || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) {
        return words[0]!.replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    }
    return words
        .map((w) => w.replace(/[^A-Za-z0-9]/g, ""))
        .filter(Boolean)
        .map((w) => w[0]!)
        .join("")
        .slice(0, 3)
        .toUpperCase();
}
